var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "comment-form-modal",
        centered: "",
        "hide-header": "",
        "hide-footer": "",
      },
      on: {
        close: function ($event) {
          _vm.isOpen = false
        },
      },
      model: {
        value: _vm.isOpen,
        callback: function ($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _c("div", { staticClass: "comment-form" }, [
        _c("div", { staticClass: "comment-form__title" }, [
          _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
          _vm.parentCommentAuthor
            ? _c("div", { staticClass: "author" }, [
                _vm.parentCommentAuthor.link
                  ? _c(
                      "a",
                      {
                        staticClass: "author__name",
                        attrs: {
                          href: _vm.parentCommentAuthor.link,
                          target: "_blank",
                        },
                      },
                      [_vm._v(_vm._s(_vm.parentCommentAuthor.name))]
                    )
                  : _c("span", { staticClass: "author__name" }, [
                      _vm._v(_vm._s(_vm.parentCommentAuthor.name)),
                    ]),
              ])
            : _vm._e(),
        ]),
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.submit.apply(null, arguments)
              },
            },
          },
          [
            _c("c-textarea", {
              attrs: { "floating-label": "Комментарий" },
              model: {
                value: _vm.text,
                callback: function ($$v) {
                  _vm.text = $$v
                },
                expression: "text",
              },
            }),
            _c("file-loader", {
              ref: "loader",
              staticClass: "comment-form__loader",
              attrs: {
                format: "images,pdf,docs",
                actions: "loadFiles,preview",
                links: _vm.fileLinks,
              },
              on: {
                changeLinks: function ($event) {
                  _vm.fileLinks = $event
                },
              },
              model: {
                value: _vm.files,
                callback: function ($$v) {
                  _vm.files = $$v
                },
                expression: "files",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "comment-form__actions" },
          [
            _c("c-button", {
              staticClass: "comment-form__reset",
              attrs: { label: "Отменить" },
              on: { click: _vm.close },
            }),
            _c("c-button", {
              staticClass: "comment-form__submit",
              attrs: { color: "primary", label: "Отправить" },
              on: { click: _vm.submit },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }